module.exports = __webpack_public_path__ + "img/1.645abc17.png";